import "./styles.css"

const Footer = () => {
  return <footer>
    <p>Copyright &copy; Luis Henrique - 2026</p>
  </footer>;
};

export default Footer;